<template>
    
    <div class="col backgroundForm">
        <div class="col col-md-6 offset-md-3">
            <div class="alert alert-success" role="alert">
                <h4 class="alert-heading">Busqueda de Embarcaciones</h4>
                <p>Indique su {{ searchType }}</p>
                <hr>
            </div>
            <form @submit.prevent="searchBoat">

                <div class="btn-group btn-group-toggle" data-toggle="buttons">
                    <label class="btn btn-success active" @click="mViewSearch">
                        <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" v-model="optionSearch"  value="enrollment" checked> Nombre
                    </label>
                    <label class="btn btn-success" @click="mViewSearch">
                        <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2" v-model="optionSearch" value="name"> Matricula
                    </label>
                </div>

                <div class="form-group"> 
                    <label for="nombreEmbarcacion">{{ searchType }}</label>
                    <input type="text" class="form-control" id="enrollment_boat" v-model="enrollment_boat" :placeholder="searchType" autocomplete="off">
                    <small id="enrollmentHelp" class="form-text text-muted">Teclee {{ searchType }} </small>
                </div>
                <button class="btn btn-lg btn-outline-primary col col-md-4 offset-md-4" >Buscar</button>
            </form>
        </div>
        <br><br>
        <transition name="bounce">
        <div class="col-12 col-md-10 offset-md-1 table-responsive" v-if="statusSearch">
            <table class="table table-striped">
                <thead class="thead-dark">
                    <tr>
                        <th scoped="col">#</th>
                        <th scoped="col">Nombre Embarcacion</th>
                        <th scoped="col">Tipo</th>
                        <th scoped="col">Matricula</th>
                        <th scoped="col">Despachar</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(boat, index) in boats" :key="boat.id">
                        <td>{{ index+1 }}</td>
                        <td>{{ boat.name_boat }}</td>
                        <td>{{ boat.detail_boat }}</td>
                        <td v-if="boat.enrollment">{{ boat.enrollment }}</td>
                        <td v-if="boat.enrollment_old">{{ boat.enrollment_old }}</td>
                        <td><button class="btn btn-outline-warning" @click="getBoat(boat)">Abrir</button></td>
                    </tr>
                </tbody>
            </table>
        </div>
        </transition>
    </div>
    
</template>
<script>
import Vue from 'vue';
import axios from 'axios';
import qs from 'qs';
// import { EventBus } from '@/helpers/EventBus';
// import boatRegister from './boatRegister'



export default {
    name:'search-boat',
    data(){
        return{
            statusSearch:false,
            enrollment_boat:null,
            boats:[],
            activeBoat:{},
            optionSearch:'name',
        }        
    },
    computed:{
        searchType(){
            switch(this.optionSearch){
                case 'name':
                    return 'Nombre de la Nave';
                break;

                case 'enrollment':
                    return 'Matricula de la Nave';
                break;
            }
        },
        viewSearch(){
            switch(this.optionSearch){
                case 'name':
                    this.vSearch=true;
                break;

                case 'enrollment':
                    this.vSearch=false;
                break;
            }
            return this.vSearch;
        },
    },
    methods:{
        searchBoat(){
            this.boats=[];
            this.statusSearch=false;
            if(this.enrollment_boat){
                
                // axios.get(`searchNameBoat/${this.optionSearch}/${this.enrollment_boat}`)
                axios.get(`searchNameBoat/${this.optionSearch}/${this.enrollment_boat}?api_token=${Vue.auth.getToken()}`)                
                .then((res) => {
                    if(res.data.length > 0){
                        this.boats=res.data;
                        this.statusSearch=true;
                    }else{
                        toastr.info('No hemos encontrado aproximaciones', 'Advertencia')
                    }
                }).catch(error => {
                    console.log(error);
                })
            }
        },
        getBoat(boat){
            this.activeBoat=boat;
            
            this.$store.dispatch('addBoat', boat)
            this.$store.dispatch('changeDisabled',true)
            this.$router.push('not-register');
        },
        mViewSearch(event){
            var radios=$("input[type=radio]").parents('label');
            let radioV;                
                for(let i=0;i<radios.length;i++){                    
                    if($(radios[i]).hasClass('active')){
                        radioV=$(radios[i]).children('input').attr('value');
                    }
                }
            //console.log(radioV);
            this.optionSearch=radioV;
        }
    }
}
</script>

<style>
.bounce-enter-active {
    animation: bounce-in .5s;
  }
  .bounce-leave-active {
    animation: bounce-in .5s reverse;
  }
  @keyframes bounce-in {
    0% {
      transform: scale(0);
    }
    50% {
      transform: scale(1.5);
    }
    100% {
      transform: scale(1);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/cotizacion/searchBoat.vue